import { getCookie } from "../utils/cookies";
const HUBSPOT_HUTK_KEY = 'hubspotutk';
export const submitHubspotForm = async (form, formId, portalId) => {
    try {
        const context = {
            hutk: form.context.hutk || getCookie(HUBSPOT_HUTK_KEY),
            ...form.context
        };
        const response = await window.fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...form, context }),
        });
        if (response.ok) {
            return { success: true };
        }
        else {
            const message = `Hubspot form submition api failed with status ${response.status} for form ${formId} and ${portalId}`;
            console.error(message);
            const body = await response.json();
            return {
                success: false,
                errors: body.errors ? body.errors : [{
                        message,
                    }],
            };
        }
    }
    catch (error) {
        console.error(error);
        return {
            success: false,
            errors: error ? [{
                    errorType: error.name,
                    message: error.message,
                    stack: error.stack
                }] : undefined,
        };
    }
};
export const submitHubspotFormRetry = async (form, formId, portalId, retry) => {
    let currentAttempt = 0;
    let result;
    while (currentAttempt < retry.attempts) {
        currentAttempt++;
        result = await submitHubspotForm(form, formId, portalId);
        if (result.success) {
            return result;
        }
        if (currentAttempt < retry.attempts) {
            await new Promise((resolve) => setTimeout(resolve, retry.interval));
        }
    }
    return result || { success: false };
};
//# sourceMappingURL=data:application/json;base64,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